module.exports = __webpack_public_path__ + "static/media/find-provider-home.b8898844.svg";